import {User} from './user';
import {Action} from './events';

export class Message {
  public user: User;
  public content: string;
  public action: Action;
  public channel: number;
  public createdAt: Date;
  public chatType: number;

  constructor(user,  content, channel, createdAt, chatType) {
    this.user = user;
    this.content = content;
    this.channel = channel;
    this.createdAt = createdAt;
    this.chatType = chatType;
  }

  public getUser() {
    return this.user;
  }

  public getContent() {
    return this.content;
  }
}
